/**
 * Asynchronously loads OffersPage
 */
import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import(/* webpackChunkName: "OffersPage" */ './index'),
  loading: () => null,
});
